import React, { useState } from "react";
import { Titlesubtitle } from "../../components/common/titlesubtitle";
import Singleinput from "../../components/common/inputs/singleinput";
import { Platformbutton } from "../../components/common/buttons";
import { Progress } from "../../components/common/progress";
import { useStep } from "../../helpers/hooks";
import { Success } from "../../components/common/success";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { verifyEmail } from "../../appredux/actions/authAction";
import { useSelector } from "react-redux";
import { Formik } from "formik";
import { Formcol } from "../../components/common/common";
import { AlertError } from "../../components/common/alertinfo";
import { addApiSuffix } from "../../helpers/helpers";
import { setLocalStorage } from "../../helpers/utils";
import { baseUrl2 } from "../../appredux/api";
import axios from "axios";
import { headers } from "../../appredux/constants";
import { useLocation } from 'react-router-dom';
import { openNotificationWithIcon, openNotificationWithIconRedErr } from "../../appredux/actions/common";

const Verifyemail = (props)=> {
    const [data, setData] = useState({
        email:props.email || '',
        contno:props.contno || '',
        contId:props.contId ||  '',
        token:props.token
    })

    const {step, nextStep, prevStep,setStep}  = useStep(0)

    let { authLoad, authMessage } = useSelector(state => state.common)

    let handleInput = (e)=> {
        var name= e.target.name
        var value = e.target.value
        setData(({...data, [name]: value}))
    }

    let sendUserMail = ()=> {

        
        props.verifyEmail(addApiSuffix('auth/send-email-verification-link'), {email:data.email,contId:"CONT-"+data.contId}, ()=> {
            setLocalStorage('emailverify', {contId:"CONT-"+data.contId})
            setStep(3)})

    }
    React.useEffect(()=> {

        props.token && setStep(1)

        // eslint-disable-next-line
    },[])
    switch (step) {
        case 0:
            return <Verifymail email={data.email} contId={props.contId} handleInput={handleInput}  authMessage={authMessage} authLoad={authLoad} sendUserMail={sendUserMail}  continue = {nextStep} back={prevStep} />
        // case 1:
        //     return <Verifycode data={data} setData={setData} authMessage={authMessage} authLoad={authLoad} sendUserMail={sendUserMail}  resetPassword={props.resetPassword} continue = {nextStep} back={prevStep} />
        case 1:
            return <Confirmverlink data={data} authMessage={authMessage} authLoad={authLoad} sendUserMail={sendUserMail}   resetPassword={props.resetPassword}  continue={nextStep} back={prevStep} />
        case 3:
            return <>
            <Progress/>
                <Success
                    title="Email Verification"
                    subtitle="We sent you an email."
                    addOns={'items-center justify-center'}
                />
            </> 
        default:
            return <></>
    }
    
}

const Verifymail = (props)=> {
    const navigate = useNavigate()

    let goToLogin = ()=> {
        navigate('/auth/login')
        
    }
    return (
        <div className="flex flex-col gap-[50px]">
            <Progress width={`w-[50%]`}/>
            <div className="flex flex-col gap-[30px]">
                <Titlesubtitle 
                    title="Email Verification"
                />
                <Formcol>
                    <Singleinput
                        name="email"
                        type="email"
                        value={props.email}
                        label="Email Address"
                        autoComplete="off"
                        onChange={props.handleInput}
                    />
                    <Singleinput
                        prefix="CONT-"
                        name="contId"
                        addOns="pl-[4.3em] font-[600]"
                        type="text"
                        value={props.contId}
                        label="Contact ID"
                        autoComplete="off"
                        onChange={props.handleInput}
                    />
                    
                </Formcol>
                
            </div>
            <Formcol>
                {
                    props.authMessage && <AlertError body={props.authMessage} />
                }
                <div className="w-full flex flex-col gap-[20px] items-center">
                    <Platformbutton type="normal" name="Verify Email" click={props.sendUserMail} 
                    disabled={!props.email  || props.authLoad ? true :false} loadiing={props.authLoad}/>
                    <Platformbutton type="link" text="Got an account?" title="Sign in" click="goToLogin" />
                </div>
            </Formcol>
            
        </div>
    )
}


const Confirmverlink = (props)=> {


    const navigate = useNavigate()

    ///get link code


    ///

    let location = useLocation();
        

    let goToLogin = ()=> {
        localStorage.clear('password')
        navigate('/auth/login')
    }
     let handleReset = (values)=> {

        const contcno = props.data.contno.toLowerCase();

        console.log(contcno);

         axios.post(baseUrl2+"api/auth/confirm-email-verification-link",{token:props.data.token,contId:props.data.contno},headers)
            .then((res) => {                
                if(res){

                    openNotificationWithIcon('Email Succesfully Verified','Email Verification')
                    setTimeout(() => {
                        window.location = "/auth/login";
                    }, 3000);
    
                }
              }).catch((err) =>{

                openNotificationWithIconRedErr(err.response.data.message,'Error In Verification')


              });

    
    }
    return (
        <div className="flex flex-col gap-[50px]">
            <Progress width={`w-[90%]`}/>
            <div className="flex flex-col gap-[30px]">
                <Titlesubtitle 
                    title="Verify your Email"
                />

                <Formik
                    initialValues={{
                        password: ''
                    }}
                    //validationSchema={ResetPassSchema}
                    onSubmit={handleReset}
                >
                    {(formik) => {
                        const { handleSubmit } = formik;
                        return (
                            <form onSubmit={handleSubmit} className="flex flex-col gap-[20px]">
                                <div className="flex flex-col gap-[10px]">
                                   
                                </div>
                                <Formcol>
                                    {
                                        props.authMessage && <AlertError body={props.authMessage} />
                                    }
                                     <div className="w-full flex flex-col gap-[20px] items-center">
                                        <Platformbutton type="submit" name={props.authLoad ? 'Verifying Email' :"Click Here to Verify"} loading={props.authLoad} disabled={props.authLoad } />
                                        <Platformbutton type="link" text="Got an account?" title="Sign in" click={goToLogin} />
                                    </div>
                                </Formcol>
                               
                            </form>
                        )
                    }}
                </Formik>
            </div>

           
        </div>
    )
}



const mapStateToProps = ({ common}) => {
    const {valMessage} = common;
    return {
        valMessage,
    };
};


const mapDispatchToProps = {
    verifyEmail
};
  
export default connect( mapStateToProps,mapDispatchToProps)(Verifyemail);